import { useContext } from "react"
import { schoolHooks, HeaderButtons } from "."
import { SchoolContext } from "./SchoolContext"

const TabComponent = () => {
    const { selectedTab } = useContext(SchoolContext)
    const tabs = schoolHooks.useTabs()

    const Component =
        tabs[selectedTab].component



    return (
        <div className={`content ${tabs[selectedTab].overflow ? "overflow" : "hide-overflow"}`}>
            <HeaderButtons />
            {Component && <Component />}
        </div>
    )
}

export default TabComponent